import React, { useEffect, useState } from 'react';
import { adminApi } from './adminApi';
import { Activity, Mail, FileText, Briefcase, LogIn, Send, Layers } from 'lucide-react';

const ICONS = {
  login: LogIn,
  case_studies_reordered: Layers,
  broadcast_sent: Send,
  broadcast_drafted: Send,
  default: Activity,
};

const AdminAuditLog = () => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.auditLog(200).then(setEntries).finally(() => setLoading(false));
  }, []);

  return (
    <div className="px-8 lg:px-12 py-10 max-w-4xl" data-testid="admin-audit-page">
      <header className="mb-8">
        <p className="text-[#83BF42] text-xs uppercase tracking-[0.2em] font-['Inter'] mb-2">System</p>
        <h1 className="text-white text-4xl font-light font-['Inter']">Activity</h1>
        <p className="text-white/40 text-sm font-['Lato'] mt-2">
          Recent admin actions, in reverse-chronological order.
        </p>
      </header>

      <div className="bg-[#15151A] border border-white/5 rounded-2xl">
        {loading ? (
          <div className="flex justify-center py-16">
            <div className="w-8 h-8 border-2 border-[#83BF42] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : entries.length === 0 ? (
          <p className="text-white/40 text-sm font-['Lato'] py-16 text-center" data-testid="audit-empty">
            No activity yet.
          </p>
        ) : (
          <ul className="divide-y divide-white/5">
            {entries.map((e) => {
              const Icon = ICONS[e.action] || ICONS.default;
              return (
                <li
                  key={e.id}
                  data-testid={`audit-entry-${e.id}`}
                  className="px-6 py-4 flex items-start gap-4 hover:bg-white/[0.02]"
                >
                  <div className="w-8 h-8 rounded-lg bg-[#83BF42]/10 text-[#83BF42] flex items-center justify-center shrink-0 mt-0.5">
                    <Icon className="w-3.5 h-3.5" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-white text-sm font-['Inter']">
                      <span className="text-[#83BF42]">{e.actor_email}</span>{' '}
                      <span className="text-white/40">·</span>{' '}
                      <span className="text-white/80">{e.action.replace(/_/g, ' ')}</span>
                      {e.target ? (
                        <span className="text-white/40"> on {e.target}</span>
                      ) : null}
                    </p>
                    {e.meta && Object.keys(e.meta).length > 0 && (
                      <pre className="text-white/40 text-xs font-mono mt-1 truncate">
                        {JSON.stringify(e.meta)}
                      </pre>
                    )}
                  </div>
                  <span className="shrink-0 text-white/30 text-xs font-['Lato'] mt-1">
                    {new Date(e.created_at).toLocaleString()}
                  </span>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default AdminAuditLog;
